export interface FaqItem {
  question: string;
  answer: string;
}

export const faqData: FaqItem[] = [
  {
    question: '如何注册盛世娱乐账号？',
    answer: '访问盛世娱乐官网，点击右上角"注册"按钮，输入手机号码、设置登录密码并获取短信验证码，同意用户协议后即可完成注册。整个过程仅需1分钟左右。',
  },
  {
    question: '盛世娱乐支持哪些充值方式？',
    answer: '盛世娱乐支持微信支付、支付宝、银行卡转账以及USDT数字货币充值等多种方式。所有充值均为即时到账，无需等待。首次充值用户还可享受新人专属礼包。',
  },
  {
    question: '提现需要多长时间到账？',
    answer: '盛世娱乐支持快速提现服务。普通用户提交提现申请后，审核通过后通常在30分钟内到账。VIP会员可享受优先提现通道，钻石及以上等级会员最快5分钟到账。',
  },
  {
    question: '平台游戏是否公平公正？',
    answer: '盛世娱乐所有游戏均采用国际认证的随机数生成器（RNG），确保每局结果完全随机。真人视讯采用实时视频直播，荷官操作全程透明。平台定期接受第三方独立审计，确保游戏公平性。',
  },
  {
    question: '如何成为盛世娱乐VIP会员？',
    answer: 'VIP会员根据累计充值金额和活跃度综合评定。当您的账户满足相应条件后，系统会自动升级您的VIP等级。您也可以在个人中心查看当前等级和升级进度。',
  },
  {
    question: '忘记密码怎么办？',
    answer: '点击登录页面的"忘记密码"链接，输入注册手机号码获取验证码，验证通过后即可设置新密码。如遇到任何问题，可联系24小时在线客服获取帮助。',
  },
  {
    question: '平台是否支持手机端访问？',
    answer: '盛世娱乐全面支持移动端访问。您可以通过手机浏览器直接访问官网，或下载官方APP（iOS和Android版本均已上线），随时随地畅享娱乐体验。',
  },
  {
    question: '遇到问题如何联系客服？',
    answer: '盛世娱乐提供7×24小时全天候客服支持。您可以通过官网在线客服窗口、官方客服邮箱（support@shengshientertainment.com）或VIP专属服务热线获取帮助。客服团队将在最短时间内为您解决问题。',
  },
];